import React, { useEffect, useState } from "react";
import { useGameController } from "../hooks/useGameController.ts";

export function DeathGUI() {
    const [show, setShow] = useState(false);

    const gameController = useGameController();
    useEffect(() => {
        const handler = (event, playerData) => {
            if(gameController.gameState.status === "game-over"){
                setShow(true);
            }
        };
        gameController.addEventHandler(["game:status:updated"], 'death-gui', handler);
        return () => {
            gameController.removeEventHandler(["game:status:updated"], 'death-gui', handler);
        };
    }, []);
    return show ? (
        <div className="quest-success-overlay" style={{backgroundColor: "#111"}}>
            <h1>Game Over</h1>
        </div>
    ) : null;
}
